import React, { Component } from 'react';
import { Button, Modal } from 'react-bootstrap';
import SignatureCanvas from 'react-signature-canvas';
import { getUserAuthToken } from '../../../../services/common/util';
import { ModalStyled } from '../../../../theme/customizedStyleComponents';

export default class SignatureField extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showSignaturePad: false,
            preview: null
        };
        this.sigCanvasRef = React.createRef();
        this.fileInputRef = React.createRef();
    }

    componentDidMount() {
        if (this.props.value && typeof this.props.value === 'string' && !this.props.value.startsWith('data:')) {
            this.setState({
                preview: process.env.REACT_APP_BACKENDURL + this.props.value + '?token=' + getUserAuthToken()
            });
        }
    }

    handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onloadend = () => {
            const fileData = {
                fileName: file.name,
                content: reader.result
            };
            this.setState({ preview: reader.result });
            this.props.onChange(this.props.fieldDef.fieldId, fileData);
        };
        reader.readAsDataURL(file);
    };

    openSignaturePad = () => {
        this.setState({ showSignaturePad: true });
    };

    closeSignaturePad = () => {
        this.setState({ showSignaturePad: false });
    };

    clearSignature = () => {
        if (this.sigCanvasRef.current) {
            this.sigCanvasRef.current.clear();
        }
    };

    saveSignature = () => {
        if (this.sigCanvasRef.current && !this.sigCanvasRef.current.isEmpty()) {
            const dataUrl = this.sigCanvasRef.current.getTrimmedCanvas().toDataURL('image/png');
            const fileData = {
                fileName: 'signature.png',
                content: dataUrl
            };
            this.setState({ preview: dataUrl, showSignaturePad: false });
            this.props.onChange(this.props.fieldDef.fieldId, fileData);
        }
    };

    handleBrowse = () => {
        if (this.fileInputRef.current) {
            this.fileInputRef.current.click();
        }
    };

    render() {
        const { fieldDef, hasError, errorMessage, disabled } = this.props;
        const isRequired = fieldDef.validation && fieldDef.validation.required;

        return (
            <div className="form-group">
                <label>
                    {fieldDef.label}
                    {isRequired && <span className="text-danger"> *</span>}
                </label>
                <div>
                    <input
                        className="d-none"
                        type="file"
                        ref={this.fileInputRef}
                        onChange={this.handleFileUpload}
                        accept="image/*"
                        disabled={disabled}
                    />
                    <button
                        type="button"
                        className="btn btn-outline-info btn-sm mr-2"
                        onClick={this.handleBrowse}
                        disabled={disabled}
                    >
                        <i className="fa fa-upload" /> Upload Image
                    </button>
                    <button
                        type="button"
                        className="btn btn-outline-secondary btn-sm"
                        onClick={this.openSignaturePad}
                        disabled={disabled}
                    >
                        <i className="fa fa-pencil-alt" /> Draw Signature
                    </button>
                    {this.state.preview && (
                        <div className="mt-2">
                            <img
                                src={this.state.preview}
                                alt="Signature"
                                style={{ maxWidth: '200px', maxHeight: '100px', border: '1px solid #ddd' }}
                            />
                        </div>
                    )}
                </div>
                <div className={hasError ? 'inline-errormsg' : 'hidden'}>
                    <i className="fa fa-exclamation-circle" aria-hidden="true">
                        &nbsp;{errorMessage || 'This field is required.'}
                    </i>
                </div>

                <ModalStyled
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.showSignaturePad}
                    onHide={this.closeSignaturePad}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Draw Signature</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div style={{ border: '1px solid #ccc' }}>
                            <SignatureCanvas
                                ref={this.sigCanvasRef}
                                penColor="black"
                                canvasProps={{ width: 450, height: 200, className: 'sigCanvas' }}
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.clearSignature}>
                            Clear
                        </Button>
                        <Button variant="primary" onClick={this.saveSignature}>
                            Save Signature
                        </Button>
                    </Modal.Footer>
                </ModalStyled>
            </div>
        );
    }
}
